import React, { useEffect, useState } from "react";
import "./QualityPolicy.css";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Certification_Modal from "../../../../../../common/common_modal/certification_modal/Certification_Modal";
import { Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Create,
  Delete,
  GetAll,
} from "../../../../../../../src/features/admin/quality_management/structural_requirement/quality_policy/Slice";
import { faEye, faUpload, faTrashCan } from "@fortawesome/free-solid-svg-icons";

// //
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { FixIDS } from "../../../../../../utils/fixIDS";

function Quality_Policy() {
  const dispatch = useDispatch();

  /* ================= REDUX STATE ================= */
  const quality_policy = useSelector((state) => state.quality_policy);

  const existingFile =
    Array.isArray(quality_policy?.data) && quality_policy.data.length > 0
      ? quality_policy.data[0]
      : null;

  /* ================= LOCAL STATE ================= */
  const [showViewModal, setShowViewModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    dispatch(GetAll());
  }, [dispatch]);

  /* ================= HELPERS ================= */
  const getImageUrl = (path) => {
    if (!path) return "/assets/images/other/dummy-image.png";
    return path.startsWith("http")
      ? path
      : `${process.env.REACT_APP_IMG_URL}${path}`;
  };

  const getFileName = (path) => {
    if (!path) return "";
    return path.split("/").pop();
  };

  const isPdf = (filePath = "") => filePath.toLowerCase().endsWith(".pdf");

  /* ================= FILE CHANGE ================= */
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = [
      // "application/pdf",
      "image/jpeg",
      "image/png",
      "image/webp",
    ];

    if (!allowedTypes.includes(file.type)) {
      alert(" image files are allowed");
      return;
    }

    setSelectedFile(file);
    setPreviewUrl(URL.createObjectURL(file));
  };

  /* ================= UPLOAD ================= */
  const handleUpload = async () => {
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append("name", selectedFile);

    try {
      await dispatch(Create(formData)).unwrap();
      await dispatch(GetAll());
      handleCloseUploadModal();
    } catch (err) {
      console.error("Upload failed:", err);
      alert("Upload failed");
    }
  };

  /* ================= DELETE ================= */
  const handleDelete = async () => {
    if (!existingFile?.id) return;

    try {
      await dispatch(Delete(existingFile.id)).unwrap();
      await dispatch(GetAll());
    } catch (err) {
      console.error("Delete failed:", err);
      alert("Delete failed");
    }
  };

  /* ================= CLOSE MODAL ================= */
  const handleCloseUploadModal = () => {
    setShowUploadModal(false);
    setSelectedFile(null);
    setPreviewUrl(null);
  };

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    getValues,
  } = useForm();
  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("name", data?.image[0]);

    try {
      await dispatch(Create(formData)).unwrap();
      await dispatch(GetAll());
      handleCloseUploadModal();
    } catch (err) {
      console.error("Upload failed:", err);
      alert("Upload failed");
    }
  };

  const permissions = useSelector((state) => state.auth.permissions);

  const haveReadPermission = permissions?.includes(FixIDS.quality_policy.List);
  const haveAddPermission = permissions?.includes(FixIDS.quality_policy.Add);

  return (
    <>
      {haveReadPermission && (
        <section className="Imperiality Quality_Policy">
          <div className="back_div">
            <Common_Back_Btn backText="Quality Policy" />
          </div>

          <div className="white_container customer_section">
            {/* ================= NOTE ================= */}
            <div className="note_text_holder">
              <p>
                Our company is committed to maintaining the highest standards of
                accuracy, reliability, and integrity in all laboratory
                operations. We ensure continuous improvement of our processes,
                compliance with quality standards, and customer satisfaction
                through effective documentation and controlled file management.
              </p>
            </div>

            {/* ================= FILE VIEW ================= */}
            {existingFile ? (
              <div className="file_section">
                <div className="row">
                  <div className="col-md-4">
                    <Form.Group className="form_group file_field">
                      <div className="image_holder">
                        {isPdf(existingFile.name) ? (
                          <iframe
                            src={getImageUrl(existingFile.name)}
                            // width="100%"
                            // height="250"
                            width="100%"
                            height="150px"
                            title="Quality Policy PDF"
                          />
                        ) : (
                          <img
                            className="img_preview"
                            src={getImageUrl(existingFile.name)}
                            alt="Quality Policy"
                            onError={(e) =>
                              (e.target.src =
                                "/assets/images/other/dummy-image.png")
                            }
                          />
                        )}
                      </div>

                      <div className="span_text_holder">
                        <span>{getFileName(existingFile.name)}</span>

                        <div className="d-flex gap-3 mt-2">
                          <span
                            className="green_text"
                            onClick={() => setShowViewModal(true)}
                          >
                            <FontAwesomeIcon icon={faEye} /> View
                          </span>

                          <span className="red_text" onClick={handleDelete}>
                            <FontAwesomeIcon icon={faTrashCan} /> Delete
                          </span>
                        </div>
                      </div>
                    </Form.Group>
                  </div>
                </div>
              </div>
            ) : (
              /* ================= UPLOAD BUTTON ================= */
              <div className="permission_btn_holder">
                <Button
                  className="upload_btn"
                  onClick={() => setShowUploadModal(true)}
                >
                  <FontAwesomeIcon icon={faUpload} className="me-2" />
                  Upload File
                </Button>
              </div>
            )}
          </div>
        </section>
      )}

      {/* ================= VIEW MODAL ================= */}
      {haveReadPermission && (
        <Certification_Modal
          show={showViewModal}
          onHide={() => setShowViewModal(false)}
          modalHeadingText="View Quality Policy"
          imgSrc={previewUrl || getImageUrl(existingFile?.name)}
          btnText="Download"
          title="Quality Policy"
        />
      )}

      {/* ================= UPLOAD MODAL ================= */}
      {haveAddPermission && showUploadModal && (
        <div className="modal common_modal fade show d-block" tabIndex="-1">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Upload Quality Policy</h5>
                  <button
                    className="btn-close"
                    onClick={handleCloseUploadModal}
                  />
                </div>

                <div className="modal-body">
                  <Form.Control
                    type="file"
                    {...register("image", {
                      validate: (value) => {
                        if (typeof value === "string" && value) return true;

                        if (value && value.length > 0) return true;

                        return "File is required";
                      },
                    })}
                    accept="*"
                  />

                  {(() => {
                    const fileValue = watch("image");

                    // URL for preview
                    const fileUrl =
                      typeof fileValue === "string"
                        ? process.env.REACT_APP_IMG_URL + fileValue
                        : fileValue?.length > 0
                        ? URL.createObjectURL(fileValue[0])
                        : null;

                    // Type detection
                    const fileType =
                      typeof fileValue === "string"
                        ? fileValue.toLowerCase()
                        : fileValue?.[0]?.type;

                    if (!fileUrl) return null;

                    return (
                      <div className="preview-container">
                        {/* IMAGE */}
                        {(fileType?.includes("image") ||
                          fileType?.endsWith(".jpg") ||
                          fileType?.endsWith(".jpeg") ||
                          fileType?.endsWith(".png")) && (
                          <img
                            src={fileUrl}
                            alt="Preview"
                            className="image-preview"
                            style={{ maxWidth: "100px" }}
                          />
                        )}

                        {/* PDF */}
                        {(fileType === "application/pdf" ||
                          fileType?.endsWith(".pdf")) && (
                          <iframe
                            src={fileUrl}
                            style={{ maxWidth: "100px" }}
                            title="PDF"
                          />
                        )}

                        {/* WORD */}
                        {(fileType?.includes("word") ||
                          fileType?.endsWith(".doc") ||
                          fileType?.endsWith(".docx")) && (
                          <div>
                            <p>Word preview not supported</p>
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open / Download Word File
                            </a>

                            <iframe
                              src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                              style={{ maxWidth: "100px" }}
                              title="Word Preview"
                            />
                          </div>
                        )}

                        {/* EXCEL */}
                        {(fileType?.includes("spreadsheet") ||
                          fileType?.endsWith(".xlsx") ||
                          fileType?.endsWith(".xls")) && (
                          <div>
                            <p>Excel preview not supported</p>
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open / Download Excel File
                            </a>
                          </div>
                        )}
                      </div>
                    );
                  })()}
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={handleCloseUploadModal}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    // disabled={!selectedFile}
                    type="submit"
                    // onClick={handleUpload}
                  >
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      )}
    </>
  );
}

export default Quality_Policy;
